module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wEECsB/images/cover.jpg?1684229399282",
      "alt": "This image is the cover for the book Murder in Wauwatosa, True Crime"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder in Wauwatosa, True Crime\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Investigate the mysteries surrounding the brutal murder of Wauwatos's Arthur \"Buddy\" Schumacher Jr. A must-read for fans of true crime and Wisconsin history enthusiasts.")])]), _c('br'), _c('p', [_vm._v("In 1925, the peaceful Milwaukee suburb of "), _c('i', [_vm._v("Wauwatosa")]), _vm._v(" found itself involved in mystery and horror. Eight-year-old Arthur \"Buddy\" Schumacher Jr. was last seen by three of his friends after they hopped off a freight train they'd jumped to get a ride to a nearby swimming hole.")]), _vm._v(" "), _c('p', [_vm._v(" For seven weeks, the community and state searched desperately to find the boy until his body was found just a mile from his house with his clothing torn and a handkerchief shoved down his throat. The police pursued several promising leads, but to no avail.")]), _c('p', [_vm._v(" In this engaging mystery, author Paul Hoffman walks us back to the scene of the crime and through the reasons it was never solved.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Hoffman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Paul Hoffman walks us back to the scene of the crime and through the reasons it was never solved.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0